import '../../stylesheets/App.css';
import React, {useState} from 'react';
import DetallePagoAProveedor from '../popups/DetallePagoAProveedor';
import Swal from 'sweetalert2';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getHeaders } from '../../helpers/apiCallConfiguration';

library.add(faTrash);

function DetallePagosPorCompra(props) {

    let [cargarNuevoPago, setCargarNuevoPago] = useState(false);

    const cancelarPago = async (item) => {
        let resultSwal = await Swal.fire({
            title: '¿Eliminar este pago?',
            text: 'Esta acción revertirá el saldo de la compra.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        });
        if (resultSwal.isConfirmed) {
            let result = await fetch(
                process.env.REACT_APP_API_BASE_URL + '/pagosaproveedores/deactivate',
                { method: 'PUT', headers: getHeaders(), body: JSON.stringify({ idPagoAProveedor: item.idPagoAProveedor }) }
            );
            result = await result.json();
            if (result.status == 200) {
                Swal.fire('Pago eliminado', 'El pago ha sido eliminado y el saldo recalculado.', 'success');
                props.setActualizar((act) => act + 1);
                document.querySelector('#exampleModal .btn-close').click();
            } else {
                Swal.fire('Error', 'Ha habido un error al intentar eliminar el pago.', 'warning');
            }
        }
    };

    return (
        <>
            <div className="accordion mt-3" id="accordionFlushPagos">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsePagos" aria-expanded="false" aria-controls="flush-collapsePagos">
                        Ver pagos
                    </button>
                    </h2>
                    <div id="flush-collapsePagos" className="accordion-collapse collapse" data-bs-parent="#accordionFlushPagos">
                    <div className="accordion-body">
                        <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                <th scope="col">#</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Monto</th>
                                <th scope="col">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.compra.pagos?props.compra.pagos.map((item,i)=>
                                <tr key={'tr-'+i}>
                                <th scope="row"  key={'d-'+i}>{item.idPagoAProveedor}</th>
                                <td  key={'f-'+i}>{new Date(item.fecha+'T00:00:00').toLocaleDateString()}</td>
                                <td  key={'m-'+i}>$ {item.monto.toLocaleString()}</td>
                                <td  key={'a-'+i}><FontAwesomeIcon icon={faTrash} className="pointer" onClick={()=>cancelarPago(item)}/></td>
                                </tr>
                                ):''}
                            </tbody>
                        </table>
                        </div>
                        <button type="button" className="btn btn-outline-primary" onClick={()=>setCargarNuevoPago(true)}>Registrar nuevo pago</button>
                        {cargarNuevoPago?
                        <div className="border rounded mt-3 p-2">
                            <DetallePagoAProveedor action="Registrar" settedProveedor={props.compra.idProveedor} settedCompra={props.compra.idCompra} setActualizar={props.setActualizar}/>
                        </div>:''}
                    </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default DetallePagosPorCompra;
